import React from 'react';
import classes from './SeatsMapList.scss';
import SeatsMapListItem from '../SeatsMapListItem/SeatsMapListItem';

const seatsMapList = (props) => {
    return (
        props.cabinNumber === props.wingsStart ? (
            <React.Fragment>
                <ul className={[classes.List, props.data.rchar === 'Z' ? classes.ListHidden: null].join(' ')}>
                    <div style={{minWidth: `${props.wingsWidth}px`}} className={[classes.WingLeft, classes.Wing].join(' ')}></div>
                    { props.data.rseats.reverse().map((rowData, index) => {
                        return <SeatsMapListItem columnsAfterIndex={props.columnsAfterIndex} itemIndex={index} rseats={rowData} key={index} cabinNumber={props.cabinNumber}/>
                    })}
                    <div style={{minWidth: `${props.wingsWidth}px`}} className={[classes.WingRight, classes.Wing].join(' ')}></div>
                </ul>
                {
                    props.data.rchar === 'E' ? <div className={classes.ExitRow}><p>Exit Doors</p></div> : null
                }
            </React.Fragment>
        ) : (
            <React.Fragment>
                <ul className={[classes.List, props.data.rchar === 'Z' ? classes.ListHidden: null].join(' ')}>
                    { props.data.rseats.reverse().map((rowData, index) => {
                        return <SeatsMapListItem columnsAfterIndex={props.columnsAfterIndex} itemIndex={index} rseats={rowData} key={index} cabinNumber={props.cabinNumber}/>
                    })}
                </ul>
                {
                    props.data.rchar === 'E' ? <div className={classes.ExitRow}><p>Exit Doors</p></div> : null
                }
            </React.Fragment>
        )
    );
}

export default seatsMapList;


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsMap/SeatsMapList/SeatsMapList.js